import { NavLink, useLocation } from "react-router-dom";
import GridIcon from "@/components/SVGComponents/GridIcon";
import UsersIcon from "@/components/SVGComponents/UsersIcon";
import CalendarIcon from "@/components/SVGComponents/CalendarIcon";
import SettingsIcon from "@/components/SVGComponents/SettingsIcon";
import { combineClasses } from "@/lib/utils";
import styles from "./MobileBottomNav.module.scss";

interface MobileBottomNavProps {
  activeKey?: "dashboard" | "members" | "gatherings" | "settings" | "none";
}

const NAV_ITEMS = [
  {
    key: "dashboard",
    label: "Dashboard",
    path: "/dashboard",
    icon: GridIcon,
  },
  {
    key: "members",
    label: "Members",
    path: "/members",
    icon: UsersIcon,
  },
  {
    key: "gatherings",
    label: "Gatherings",
    path: "/gatherings",
    icon: CalendarIcon,
  },
  {
    key: "settings",
    label: "Settings",
    path: "/settings",
    icon: SettingsIcon,
  },
];

const MobileBottomNav = ({ activeKey }: MobileBottomNavProps = {}) => {
  const location = useLocation();

  const isItemActive = (item: (typeof NAV_ITEMS)[number]) => {
    if (activeKey !== undefined) {
      return activeKey === item.key;
    }
    const currentPath = location.pathname;
    return currentPath === item.path || currentPath.startsWith(`${item.path}/`);
  };

  return (
    <nav className={styles.bottomNav} aria-label="Mobile navigation">
      {NAV_ITEMS.map((item) => {
        const Icon = item.icon;
        const active = isItemActive(item);
        return (
          <NavLink
            key={item.key}
            to={item.path}
            className={() =>
              combineClasses(
                styles.navItem,
                active && styles.activeItem,
              )
            }
          >
            <span className={styles.itemIcon}>
              <Icon />
            </span>
            <span className={styles.itemLabel}>{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
};

export default MobileBottomNav;
